<div class="provider-item">
  <div class="provider-details-main">
    <a class="provider-image-holder" routerLink="{{generateProviderUrl()}}">
      <img class="provider-image" src="{{getProviderImage()}}" alt="" onerror="this.src = ''">
      <div class="provider-image-overlay"></div>
      <p class="premium" *ngIf="provider.premium">PREMIUM BUSINESS</p>
    </a>
    <div class="provider-details-group">
      <div class="name-rating">
        <a class="provider-name" routerLink="{{generateProviderUrl()}}">{{provider.name}}</a>
        <p class="rating" *ngIf="provider.business_rating.rate"><img src="assets/images/star.svg" alt=""> {{provider.business_rating.rate | number : '1.0-1'}} <span>({{provider.business_rating.count}})</span></p>
      </div>
      <p class="location"><span>{{nearestDistance()}} km away</span><span>{{provider.business_location.city}} {{provider.business_location.postal_code}}</span></p>
    </div>
    <div class="provider-services">
      <div class="provider-services-list">
        <ng-container *ngFor="let service of provider.business_service | slice : 0 : 3">
          <a class="service-item" routerLink="{{fetchBookingURL(service)}}">
            <div class="service-item-detail">
              <p class="service-name" title="{{service.service_name}}">{{service.service_name}}</p>
              <p class="service-length"><img src="assets/images/provider/clock.svg" alt=""> {{service.length_of_service}}</p>
            </div>
            <p class="service-price">${{service.price}}</p>
          </a>
        </ng-container>
      </div>
    </div>
  </div>
  <button class="show-all" (click)="changeLocation()">Book online</button>
</div>